import axios from 'axios';

export default {
  get(id, confirmCode) {
    return axios.get(
      `/api/v3/open/walkin-conversion?id=${id}&confirm_code=${confirmCode}`,
    );
  },
};
